(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-mobile-toolbar"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'betseys.collection.columns';
    const mobile = window.matchMedia('(max-width: 767px)');
    let columns = '2';
    try { columns = localStorage.getItem(storageKey) === '1' ? '1' : '2'; } catch (_) {}
    let frame;
    let locked = false;
    let previousOverflow;
    const roots = () => document.querySelectorAll('.bb-collection');
    const sync = () => {
      frame = null;
      const header = document.getElementById('site-control');
      const bottom = header && getComputedStyle(header).position === 'fixed' ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const viewportOffset = window.visualViewport?.offsetTop || 0;
      let open = false;
      roots().forEach(root => {
        root.style.setProperty('--bb-viewport-offset', `${viewportOffset}px`);
        const slot = root.querySelector('.bb-toolbar-slot');
        const toolbar = root.querySelector('[data-bb-toolbar]');
        if (slot && toolbar) {
          const fixed = mobile.matches && slot.getBoundingClientRect().top <= bottom;
          const containerBottom = root.getBoundingClientRect().bottom;
          root.style.setProperty('--bb-toolbar-top', `${Math.min(bottom, containerBottom - toolbar.offsetHeight) + viewportOffset}px`);
          if (toolbar.classList.contains('bb-toolbar--fixed') !== fixed) toolbar.classList.toggle('bb-toolbar--fixed', fixed);
        }
        root.dataset.bbColumns = columns;
        root.querySelectorAll('[data-bb-layout]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bbLayout === columns)));
        open ||= mobile.matches && !!root.querySelector('.cc-product-filter.-in');
      });
      if (open && !locked) {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        locked = true;
      } else if (!open && locked) {
        document.body.style.overflow = previousOverflow;
        locked = false;
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-bb-layout]');
      if (!button) return;
      columns = button.dataset.bbLayout;
      try { localStorage.setItem(storageKey, columns); } catch (_) {}
      sync();
      button.closest('[data-bb-toolbar]').querySelector('[data-bb-layout-status]').textContent = button.dataset.status;
      window.dispatchEvent(new Event('resize'));
    });
    document.addEventListener('change', event => {
      const select = event.target.closest('[data-bb-sort]');
      if (!select) return;
      const root = select.closest('.bb-collection');
      const radio = [...root.querySelectorAll('input[name="sort_by"]')].find(input => input.value === select.value);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url);
      }
    });
    document.addEventListener('keydown', event => {
      if (!mobile.matches) return;
      const root = [...roots()].find(item => item.querySelector('.cc-product-filter.-in'));
      if (!root) return;
      const toggle = root.querySelector('[data-show-filter]');
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        toggle.click();
        toggle.focus();
      } else if (event.key === 'Tab') {
        const drawer = root.querySelector('.cc-product-filter');
        const focusable = [toggle, ...drawer.querySelectorAll('a[href], button, input, select, summary, [tabindex="0"]')].filter(item => !item.disabled && item.getClientRects().length);
        const index = focusable.indexOf(document.activeElement);
        if (event.shiftKey && index <= 0) {
          event.preventDefault();
          focusable.at(-1)?.focus();
        } else if (!event.shiftKey && (index === focusable.length - 1 || index === -1)) {
          event.preventDefault();
          focusable[0]?.focus();
        }
      }
    }, true);
    const observe = () => {
      roots().forEach(root => {
        if (root.dataset.bbObserved) return;
        root.dataset.bbObserved = 'true';
        new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      });
      sync();
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.visualViewport?.addEventListener('scroll', schedule);
    window.visualViewport?.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', observe);
    document.addEventListener('shopify:section:unload', schedule);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
    else observe();
    const header = document.getElementById('site-control');
    if (header) {
      new ResizeObserver(schedule).observe(header);
      new MutationObserver(schedule).observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-hub-cart-extras"] && !Shopify.designMode) return;
  try {
    if (!window.bbHubCartExtrasReady) {
    window.bbHubCartExtrasReady = true;
    const template = document.querySelector('[data-bb-hub-cart-extras-template]');
    if (template) {
      const text = template.dataset;
      const root = () => window.Shopify?.routes?.root || '/';
      let cart;
      let noteDraft;
      let noteDirty = false;
      let noteTimer;
      let noteOpen = false;
      let discountDraft = '';
      const messages = new Map();
      let savingNote;
      let discountBusy = false;
      let emptyBusy = false;
      let reading;
      let readAgain = false;
      let scheduled = false;
      let mountCount = 0;
      let recovering = false;
      let recoveryBusy = false;
      let activeCartChanges = 0;
      let recoveryMessage = '';
      const recoveryKey = 'bb-hub-cart-recovered-v1';
      try {
        if (sessionStorage.getItem(recoveryKey)) {
          messages.set('[data-bb-recovery-status]', text.recoveryComplete);
          sessionStorage.removeItem(recoveryKey);
        }
      } catch {}
      const panels = () => [...document.querySelectorAll('.kl-hub-route-cart .bb-hub-cart-extras')];
      const setText = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
      const status = (selector, value) => {
        messages.set(selector, value);
        panels().forEach(panel => setText(panel.querySelector(selector), value));
      };
      const codes = () => (cart?.discount_codes || []).filter(code => code.applicable).map(code => code.code);
      const render = () => {
        if (!cart) return;
        panels().forEach(panel => {
          panel.hidden = !cart.item_count;
          const shipping = panel.querySelector('.bb-hub-shipping');
          shipping.hidden = cart.currency !== 'USD' || !cart.requires_shipping;
          const threshold = Number(text.threshold);
          const remaining = Math.max(0, threshold - cart.total_price);
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: cart.currency}).format(remaining / 100);
          setText(panel.querySelector('[data-bb-shipping-text]'), remaining ? text.shippingRemaining.replace('[amount]', amount) : text.shippingReached);
          const progress = panel.querySelector('progress');
          const value = Math.min(100, Math.max(0, cart.total_price / threshold * 100));
          if (progress.value !== value) progress.value = value;
          const note = panel.querySelector('textarea');
          if (!noteDirty && note.value !== (cart.note || '')) note.value = cart.note || '';
          const applied = codes();
          panel.querySelector('[data-bb-applied-discounts]').hidden = !applied.length;
          setText(panel.querySelector('[data-bb-discount-codes]'), applied.join(', '));
        });
      };
      const readCart = async () => {
        if (reading) { readAgain = true; return reading; }
        reading = (async () => {
          try {
            const response = await fetch(`${root()}cart.js?bb_hub_cart=${Date.now()}`, {cache: 'no-store', headers: {Accept: 'application/json'}});
            if (!response.ok) return;
            cart = await response.json();
            if (!noteDirty) noteDraft = cart.note || '';
            render();
          } catch {} finally {
            reading = null;
            if (readAgain) { readAgain = false; readCart(); }
          }
        })();
        return reading;
      };
      const updateCart = async (data) => {
        const response = await fetch(`${root()}cart/update.js`, {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      };
      const saveNote = async () => {
        clearTimeout(noteTimer);
        if (savingNote) { if (!await savingNote) return false; return saveNote(); }
        if (!noteDirty) return true;
        const value = noteDraft;
        status('[data-bb-note-status]', text.saving);
        savingNote = (async () => {
          try {
            const updated = await updateCart({note: value});
            if ((updated.note || '') !== value) throw new Error('Note not saved');
            cart = updated;
            noteDirty = noteDraft !== value;
            status('[data-bb-note-status]', noteDirty ? text.saving : text.noteSaved);
            render();
            return true;
          } catch {
            status('[data-bb-note-status]', text.noteError);
            return false;
          }
        })();
        const success = await savingNote;
        savingNote = null;
        if (success && noteDirty) return saveNote();
        return success;
      };
      const renderRecovery = () => {
        if (!recovering) return;
        document.querySelectorAll('.kl-hub-route-cart').forEach(drawer => {
          let notice = drawer.querySelector(':scope > .bb-hub-cart-recovery');
          if (!notice) {
            notice = document.createElement('div');
            notice.className = 'bb-hub-cart-recovery';
            const message = document.createElement('p');
            message.setAttribute('role', 'alert');
            const retry = document.createElement('button');
            retry.type = 'button';
            retry.textContent = text.recoveryRefresh;
            retry.addEventListener('click', recoverCart);
            const close = document.createElement('button');
            close.type = 'button';
            close.textContent = text.recoveryClose;
            close.addEventListener('click', () => window.customerHubApi?.close());
            notice.append(message, retry, close);
            drawer.append(notice);
            retry.focus();
          }
          [...drawer.children].forEach(child => {
            if (child !== notice) {
              child.inert = true;
              child.dataset.bbCartRecoveryHidden = 'true';
            }
          });
          setText(notice.querySelector('p'), recoveryMessage);
          notice.querySelector('button').disabled = recoveryBusy || activeCartChanges > 0;
        });
      };
      const recoverCart = async () => {
        if (recoveryBusy || activeCartChanges) return;
        recoveryBusy = true;
        recoveryMessage = text.recoveryChecking;
        renderRecovery();
        try {
          const response = await fetch(`${root()}cart.js?bb_hub_recover=${Date.now()}`, {
            cache: 'no-store', headers: {Accept: 'application/json'}, signal: AbortSignal.timeout(10000)
          });
          if (!response.ok) throw new Error('Cart unavailable');
          const confirmed = await response.json();
          if (!Array.isArray(confirmed.items) || !Number.isInteger(confirmed.item_count)) throw new Error('Invalid cart');
          if (!await saveNote()) throw new Error('Note must be preserved');
          if (!document.querySelector('.kl-hub-modal-veil--opened .kl-hub-route-cart')) throw new Error('Cart closed');
          try { sessionStorage.setItem(recoveryKey, '1'); } catch {}
          window.location.hash = 'k-hub/cart';
          window.location.reload();
        } catch {
          recoveryBusy = false;
          recoveryMessage = text.recoveryError;
          renderRecovery();
        }
      };
      const startRecovery = () => {
        recovering = true;
        recoveryMessage = text.recoveryChecking;
        renderRecovery();
        if (!activeCartChanges) recoverCart();
      };
      const nativeFetch = window.fetch;
      window.fetch = async function (...args) {
        let tracked = false;
        try {
          const request = args[0];
          const url = new URL(typeof request === 'string' || request instanceof URL ? request : request.url, location.href);
          const method = (args[1]?.method || request?.method || 'GET').toUpperCase();
          tracked = method === 'POST' && url.origin === location.origin &&
            /\/cart\/(change|clear)(\.js)?$/.test(url.pathname) &&
            !!document.querySelector('.kl-hub-modal-veil--opened .kl-hub-route-cart');
        } catch {}
        if (!tracked) return nativeFetch.apply(this, args);
        activeCartChanges += 1;
        try {
          const response = await nativeFetch.apply(this, args);
          if (!response.ok) startRecovery();
          return response;
        } catch (error) {
          startRecovery();
          throw error;
        } finally {
          activeCartChanges -= 1;
          if (recovering && !activeCartChanges) recoverCart();
        }
      };
      const changeDiscount = async (code, remove = false) => {
        if (discountBusy || !await saveNote()) return;
        discountBusy = true;
        panels().forEach(panel => panel.querySelectorAll('[data-bb-discount-form] button, [data-bb-discount-remove]').forEach(button => button.disabled = true));
        status('[data-bb-discount-status]', text.saving);
        try {
          await readCart();
          const requested = remove ? '' : [...new Set([...codes(), code])].join(',');
          cart = await updateCart({discount: requested});
          render();
          if (!remove && !codes().some(applied => applied.toLowerCase() === code.toLowerCase())) {
            status('[data-bb-discount-status]', text.discountInvalid);
            return;
          }
          window.location.hash = 'k-hub/cart';
          window.location.reload();
        } catch {
          status('[data-bb-discount-status]', text.discountError);
        } finally {
          discountBusy = false;
          panels().forEach(panel => panel.querySelectorAll('[data-bb-discount-form] button, [data-bb-discount-remove]').forEach(button => button.disabled = false));
        }
      };
      const emptyCart = async () => {
        if (emptyBusy || discountBusy || recovering) return;
        if (!window.confirm(text.emptyConfirm)) return;
        emptyBusy = true;
        panels().forEach(panel => panel.querySelectorAll('button').forEach(button => button.disabled = true));
        status('[data-bb-empty-status]', text.saving);
        try {
          await saveNote();
          const response = await fetch(`${root()}cart/clear.js`, {method: 'POST', headers: {Accept: 'application/json'}});
          if (!response.ok) throw new Error('Cart clear failed');
          window.location.hash = 'k-hub/cart';
          window.location.reload();
        } catch {
          emptyBusy = false;
          status('[data-bb-empty-status]', text.emptyError);
          panels().forEach(panel => panel.querySelectorAll('button').forEach(button => button.disabled = false));
        }
      };
      const mount = () => {
        scheduled = false;
        renderRecovery();
        document.querySelectorAll('.kl-hub-route-cart').forEach(drawer => {
          const section = drawer.querySelector('input[inputmode="numeric"]')?.closest('section');
          if (!section || drawer.querySelector('.bb-hub-cart-extras')) return;
          const panel = template.content.firstElementChild.cloneNode(true);
          panel.dataset.mount = String(++mountCount);
          const details = panel.querySelector('details');
          details.open = noteOpen;
          panel.querySelector('summary').addEventListener('click', () => { noteOpen = !details.open; });
          details.addEventListener('toggle', () => { if (details.isConnected) noteOpen = details.open; });
          panel.querySelector('input[name="discount"]').value = discountDraft;
          panel.querySelector('input[name="discount"]').addEventListener('input', event => { discountDraft = event.target.value; });
          messages.forEach((message, selector) => setText(panel.querySelector(selector), message));
          section.after(panel);
          if (noteDirty) panel.querySelector('textarea').value = noteDraft;
          panel.querySelector('textarea').addEventListener('input', event => {
            noteDraft = event.target.value;
            noteDirty = true;
            status('[data-bb-note-status]', text.saving);
            clearTimeout(noteTimer);
            noteTimer = setTimeout(saveNote, 500);
          });
          panel.querySelector('[data-bb-note-form]').addEventListener('submit', event => { event.preventDefault(); saveNote(); });
          panel.querySelector('[data-bb-discount-form]').addEventListener('submit', event => {
            event.preventDefault();
            const field = event.currentTarget.elements.discount;
            const code = field.value.trim();
            if (!code) { field.focus(); return; }
            changeDiscount(code);
          });
          panel.querySelector('[data-bb-discount-remove]').addEventListener('click', () => changeDiscount('', true));
          panel.querySelector('[data-bb-empty-cart]').addEventListener('click', emptyCart);
          render();
          readCart();
        });
      };
      new MutationObserver(() => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(mount); }
      }).observe(document.body, {childList: true, subtree: true});
      if (window.PerformanceObserver?.supportedEntryTypes?.includes('resource')) {
        new PerformanceObserver(list => {
          if (!panels().length) return;
          if (list.getEntries().some(entry => {
            if (!['fetch', 'xmlhttprequest'].includes(entry.initiatorType)) return false;
            const url = new URL(entry.name);
            return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
          })) readCart();
        }).observe({type: 'resource'});
      }
      document.addEventListener('click', async event => {
        const link = event.target.closest('.kl-hub-route-cart a[href*="/checkout"]');
        if (!link) return;
        if (recovering) { event.preventDefault(); event.stopImmediatePropagation(); renderRecovery(); return; }
        if (!noteDirty && !savingNote && !discountBusy) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (discountBusy) { status('[data-bb-discount-status]', text.busy); return; }
        if (await saveNote()) window.location.assign(link.href);
        else {
          const panel = panels().find(p => p.getBoundingClientRect().width);
          if (panel) { panel.querySelector('details').open = true; panel.querySelector('textarea').focus(); }
        }
      }, true);
      document.addEventListener('visibilitychange', () => { if (!document.hidden && panels().length) readCart(); });
      mount();
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-hub-integration"] && !Shopify.designMode) return;
  try {
    if (!window.bbCustomerHubIntegrationReady) {
    window.bbCustomerHubIntegrationReady = true;
    let scheduled = false;
    // Keep the private preview clean without opening a welcome prompt or drawer.
    const hidePreviewBanner = (config) => {
      if (!config || typeof window.customerHubApi?.open !== 'function' ||
          window.Shopify?.theme?.role !== 'unpublished') return;
      try {
        if (!sessionStorage.getItem('customer-hub-hub-preview-token')) return;
      } catch { return; }
      document.documentElement.classList.add('bb-hub-preview-clean');
    };

    let subscribedEvents;
    let cartAjaxSubscribed = false;
    let refreshPending = false;
    let refreshQueued = false;
    const savedVariantRequests = new WeakSet();
    const hubImageProducts = new Map();
    const hubImageAttempts = new WeakMap();

    const configuration = () => document.querySelector('[data-bb-hub-integration]');

    let accountHintPending = false;
    let accountHintFinished = false;
    let accountHint;
    let accountHintAnchor;
    let accountHintTimer;
    let accountHintWatch;
    let accountHintPaused = false;
    const accountHintKey = configuration()?.dataset.launchEnabled === 'true'
      ? 'bb-hub-account-hint-live-v1' : 'bb-hub-account-hint-preview-v6';
    const visibleOnscreen = (element) => {
      if (!element || !element.checkVisibility()) return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.top >= 0 &&
        rect.bottom < window.innerHeight - 65 && rect.right > 0 && rect.left < window.innerWidth;
    };
    const hubIsOpen = () => [...document.querySelectorAll('.kl-hub-modal-veil')]
      .some((element) => element.checkVisibility() && getComputedStyle(element).opacity !== '0');
    const accountHintPopupOpen = () => [...document.querySelectorAll(
      '[role="dialog"], dialog[open], [aria-modal="true"], #shopify-pc__banner, [id^="alia-root-"], #attentive_overlay, #attentive_creative'
    )].some((element) => {
      if (element.closest('.kl-hub-modal-veil, .kl-hub-drawer, [aria-hidden="true"], [inert]') ||
          !element.checkVisibility({ opacityProperty: true, visibilityProperty: true })) return false;
      const rect = element.getBoundingClientRect();
      if (rect.width < 240 || rect.height < 100 || rect.bottom <= 0 || rect.right <= 0 ||
          rect.top >= innerHeight || rect.left >= innerWidth) return false;
      for (let parent = element; parent; parent = parent.parentElement) {
        if (getComputedStyle(parent).opacity === '0') return false;
      }
      return true;
    });
    const dismissAccountHint = () => {
      clearTimeout(accountHintTimer);
      clearInterval(accountHintWatch);
      accountHintWatch = null;
      if (!accountHint) return;
      try { localStorage.setItem(accountHintKey, '1'); } catch {}
      const hint = accountHint;
      accountHint = null;
      hint.classList.remove('is-visible');
      const descriptions = (accountHintAnchor.getAttribute('aria-describedby') || '')
        .split(/\s+/).filter((id) => id && id !== `${hint.id}-text`);
      if (descriptions.length) accountHintAnchor.setAttribute('aria-describedby', descriptions.join(' '));
      else accountHintAnchor.removeAttribute('aria-describedby');
      window.setTimeout(() => hint.remove(), 250);
    };
    const scheduleHintDismiss = () => {
      clearTimeout(accountHintTimer);
      if (!accountHint || accountHintPaused || accountHint.matches(':hover, :focus-within') ||
          accountHintAnchor.matches(':hover, :focus')) return;
      accountHintTimer = window.setTimeout(() => {
        if (accountHintPopupOpen()) updateAccountHint(configuration());
        else dismissAccountHint();
      }, 20000);
    };
    const positionAccountHint = () => {
      if (!accountHint || !visibleOnscreen(accountHintAnchor)) return;
      const rect = accountHintAnchor.getBoundingClientRect();
      const width = accountHint.getBoundingClientRect().width;
      const center = rect.left + rect.width / 2;
      const left = Math.max(12, Math.min(center - width / 2, window.innerWidth - width - 12));
      accountHint.style.left = `${left}px`;
      accountHint.style.top = `${rect.bottom + 10}px`;
      accountHint.style.setProperty('--bb-hint-arrow', `${Math.max(12, Math.min(width - 12, center - left))}px`);
    };
    const updateAccountHint = (config) => {
      if (accountHint && hubIsOpen()) dismissAccountHint();
      if (accountHint) {
        const temporarilyHidden = document.hidden || !visibleOnscreen(accountHintAnchor);
        accountHint.hidden = temporarilyHidden;
        const pauseTimer = temporarilyHidden || accountHintPopupOpen();
        if (pauseTimer && !accountHintPaused) {
          accountHintPaused = true;
          clearTimeout(accountHintTimer);
        } else if (!pauseTimer && accountHintPaused) {
          accountHintPaused = false;
          scheduleHintDismiss();
        }
        positionAccountHint();
      }
      if (!config || accountHintPending || accountHintFinished) return;
      try {
        const launchEnabled = config.dataset.launchEnabled === 'true';
        const privatePreview = window.Shopify?.theme?.role === 'unpublished' &&
          (new URLSearchParams(location.search).has('hub-preview') ||
           sessionStorage.getItem('customer-hub-hub-preview-token'));
        if ((!launchEnabled && !privatePreview) || localStorage.getItem(accountHintKey)) return;
      } catch { return; }
      const anchor = document.querySelector('#site-control .nav-account[href="#k-hub"]');
      if (!visibleOnscreen(anchor) || document.hidden) return;
      if (!accountHintWatch) {
        accountHintWatch = window.setInterval(() => updateAccountHint(configuration()), 500);
      }
      if (hubIsOpen()) return;
      accountHintPending = true;
      requestAnimationFrame(() => {
        accountHintPending = false;
        if (!visibleOnscreen(anchor) || document.hidden || hubIsOpen()) return;
        try {
          if (localStorage.getItem(accountHintKey)) return;
        } catch { return; }
        accountHintFinished = true;
        accountHintAnchor = anchor;
        const hint = document.createElement('div');
        hint.id = 'bb-hub-account-hint';
        hint.className = 'bb-hub-account-hint';
        const message = document.createElement('span');
        message.id = `${hint.id}-text`;
        message.setAttribute('role', 'tooltip');
        message.textContent = config.dataset.accountHint;
        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'bb-hub-account-hint__close';
        closeButton.setAttribute('aria-label', config.dataset.accountHintDismiss);
        closeButton.textContent = '×';
        closeButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const restoreFocus = document.activeElement === closeButton;
          dismissAccountHint();
          if (restoreFocus) anchor.focus({ preventScroll: true });
        });
        hint.append(message, closeButton);
        document.body.append(hint);
        anchor.setAttribute('aria-describedby', [anchor.getAttribute('aria-describedby'), message.id].filter(Boolean).join(' '));
        accountHint = hint;
        positionAccountHint();
        requestAnimationFrame(() => {
          if (accountHint !== hint) return;
          hint.classList.add('is-visible');
          updateAccountHint(config);
          scheduleHintDismiss();
        });
        [anchor, hint].forEach((element) => {
          element.addEventListener('pointerenter', () => clearTimeout(accountHintTimer));
          element.addEventListener('pointerleave', scheduleHintDismiss);
        });
        anchor.addEventListener('focus', () => clearTimeout(accountHintTimer));
        anchor.addEventListener('blur', scheduleHintDismiss);
        hint.addEventListener('focusin', () => clearTimeout(accountHintTimer));
        hint.addEventListener('focusout', () => requestAnimationFrame(scheduleHintDismiss));
      });
    };

    window.addEventListener('scroll', positionAccountHint, { passive: true });
    window.addEventListener('resize', positionAccountHint, { passive: true });
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !accountHintPaused && !accountHintPopupOpen()) dismissAccountHint();
    }, true);
    document.addEventListener('visibilitychange', () => {
      updateAccountHint(configuration());
    });

    const repairHubImage = async (image) => {
      const source = image.getAttribute('src') || '';
      if (source && !source.startsWith('data:image/svg+xml') &&
          !(image.complete && image.naturalWidth === 0)) return;
      const card = image.closest('.kl-hub-product-info');
      const link = card?.querySelector('.kl-hub-product-info__product-name a');
      if (!link) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
      const title = card.querySelector('.kl-hub-product-info__variant-name')?.textContent.trim() || '';
      const key = `${url.pathname}:${title}:${source}`;
      if (hubImageAttempts.get(image) === key) return;
      hubImageAttempts.set(image, key);
      try {
        const pathname = url.pathname.replace(/\/$/, '');
        if (!hubImageProducts.has(pathname)) {
          hubImageProducts.set(pathname, fetch(`${pathname}.js`, {
            headers: { Accept: 'application/json' }
          }).then((response) => response.ok ? response.json() : null).catch(() => null));
        }
        const product = await hubImageProducts.get(pathname);
        if (!product) return;
        const variants = (product.variants || []).filter((variant) => variant.title === title);
        const variantImage = variants.length === 1 ? variants[0].featured_image?.src : null;
        const candidate = variantImage || product.featured_image || product.images?.[0];
        if (!candidate) return;
        const replacement = new URL(candidate, location.href);
        if (replacement.protocol !== 'https:') return;
        replacement.searchParams.set('width', '320');
        const probe = new Image();
        await new Promise((resolve, reject) => {
          probe.onload = resolve;
          probe.onerror = reject;
          probe.src = replacement.href;
        });
        if (!image.isConnected || (image.getAttribute('src') || '') !== source ||
            link.href !== url.href ||
            (card.querySelector('.kl-hub-product-info__variant-name')?.textContent.trim() || '') !== title) return;
        image.removeAttribute('srcset');
        image.src = replacement.href;
        if (!image.alt) image.alt = product.title || link.textContent.trim();
        hubImageAttempts.delete(image);
      } catch {}
    };

    const refreshCart = async () => {
      if (refreshPending) {
        refreshQueued = true;
        return;
      }
      refreshPending = true;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (!Number.isInteger(cart.item_count)) return;
        document.querySelectorAll('[data-bb-cart-link]').forEach((link) => {
          const count = link.querySelector(':scope > div');
          if (count) count.textContent = cart.item_count;
          const label = link.querySelector('.text-link, .nav-text');
          if (label) {
            label.textContent = `${link.dataset.bbCartLabel}${cart.item_count > 0 ? ` (${cart.item_count})` : ''}`;
          }
        });
        document.dispatchEvent(new CustomEvent('theme:cartchanged'));
      } catch {
      } finally {
        refreshPending = false;
        if (refreshQueued) {
          refreshQueued = false;
          refreshCart();
        }
      }
    };

    const handleCartAdded = async () => {
      await refreshCart();
      if (configuration()?.dataset.cartEnabled !== 'true') return;
      if (typeof window.closeThemeModal === 'function') window.closeThemeModal(true, null, false);
      openAccountHub(document.querySelector('[data-bb-cart-link]'), configuration(), '/cart');
    };

    const addSavedVariant = async (button, product, config) => {
      if (savedVariantRequests.has(button)) return;
      savedVariantRequests.add(button);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      let status = product.querySelector('.bb-hub-saved-variant-status');
      if (!status) {
        status = document.createElement('p');
        status.className = 'bb-hub-saved-variant-status';
        status.setAttribute('role', 'status');
        button.after(status);
      }
      status.replaceChildren();
      const link = product.querySelector('.kl-hub-product-info__product-name a');
      const savedTitle = product.querySelector('.kl-hub-product-info__variant-name')?.textContent.trim();
      const productUrl = new URL(link.href, window.location.href);
      try {
        const response = await fetch(`${productUrl.pathname}.js`, {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Product lookup failed');
        const data = await response.json();
        const matches = data.variants.filter((variant) => variant.title === savedTitle);
        const variant = matches.length === 1 ? matches[0] : null;
        if (!variant || !variant.available || data.requires_selling_plan) {
          status.textContent = config.dataset.savedUnavailable;
          if (variant) productUrl.searchParams.set('variant', variant.id);
          const choose = document.createElement('a');
          choose.href = productUrl.href;
          choose.textContent = config.dataset.savedOptions;
          status.append(' ', choose);
          return;
        }
        const added = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
        if (!added.ok) throw new Error('Cart add failed');
        status.textContent = config.dataset.savedAdded;
        await handleCartAdded();
      } catch {
        status.textContent = config.dataset.savedError;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        savedVariantRequests.delete(button);
      }
    };

    const updateHub = () => {
      scheduled = false;
      const config = configuration();
      hidePreviewBanner(config);
      updateAccountHint(config);
      if (config) {
        document.querySelectorAll('.kl-hub-drawer .kl-hub-product-info img.kl-hub-img').forEach(repairHubImage);
        document.querySelectorAll('.klaviyo-favorites-plp-slot button').forEach((button) => {
          const active = Boolean(button.querySelector('.kl-hub-wishlist-icon--active'));
          const label = active ? config.dataset.favoriteRemove : config.dataset.favoriteAdd;
          if (label && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
        });
      }
      const card = config?.content.querySelector('.bb-hub-locations');
      const summaries = [...document.querySelectorAll('.kl-hub-drawer .kl-hub-summary')];
      const summary = summaries.at(-1);
      document.querySelectorAll('.kl-hub-drawer .bb-hub-locations').forEach((existing) => {
        if (existing.parentElement !== summary) existing.remove();
      });
      if (summary) {
        const existing = summary.querySelector('.bb-hub-locations');
        if (card) {
          const destination = new URL(card.querySelector('a').getAttribute('href'), document.baseURI).href;
          const nativeLink = [...summary.querySelectorAll('a')].some((link) =>
            !link.closest('.bb-hub-locations') && link.href === destination
          );
          if (nativeLink) {
            existing?.remove();
          } else if (!existing || existing.querySelector('a').href !== destination) {
            existing?.remove();
            const copy = card.cloneNode(true);
            const top = summary.querySelector('.kl-hub-summary__top');
            if (top) top.after(copy);
            else summary.prepend(copy);
          }
        } else {
          existing?.remove();
        }
      }

      if (config && !cartAjaxSubscribed && typeof window.jQuery === 'function') {
        cartAjaxSubscribed = true;
        window.jQuery(document).on('ajaxSuccess.bbCustomerHubCart', (event, response, request) => {
          const url = new URL(request.url, window.location.href);
          if (url.origin === window.location.origin && /\/cart\/add(\.js)?$/.test(url.pathname) &&
              (request.type || request.method || '').toUpperCase() === 'POST' &&
              response.status >= 200 && response.status < 300) handleCartAdded();
        });
      }

      const events = config ? window.customerHubApi?.events : null;
      if (events !== subscribedEvents) {
        subscribedEvents?.removeEventListener('addtocart', handleCartAdded);
        subscribedEvents = events;
        subscribedEvents?.addEventListener('addtocart', handleCartAdded);
      }
    };

    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(updateHub);
    };

    let accountOpenTimer;
    let accountOpeningAnchor;
    const openAccountHub = (anchor, config, route = '/') => {
      if (!config) return;
      clearTimeout(accountOpenTimer);
      accountOpeningAnchor?.removeAttribute('aria-busy');
      accountOpeningAnchor = anchor;
      anchor?.setAttribute('aria-busy', 'true');
      document.querySelector('.bb-hub-availability-message')?.remove();
      const started = Date.now();
      let lastAttempt = 0;
      const finish = () => {
        anchor?.removeAttribute('aria-busy');
        accountOpeningAnchor = null;
      };
      const tryOpen = () => {
        const now = Date.now();
        if (typeof window.customerHubApi?.open === 'function' && now - lastAttempt >= 500) {
          lastAttempt = now;
          try { window.customerHubApi.open(route); } catch {}
        }
        const drawer = document.querySelector('.kl-hub-modal-veil--opened .kl-hub-drawer');
        if (drawer && drawer.getBoundingClientRect().width > 0) {
          finish();
        } else if (now - started >= (route === '/cart' ? 5000 : 30000)) {
          finish();
          if (route === '/favorites') {
            const message = document.createElement('div');
            message.className = 'bb-hub-availability-message';
            const text = document.createElement('span');
            text.setAttribute('role', 'status');
            text.textContent = config.dataset.favoritesUnavailable;
            const close = document.createElement('button');
            close.type = 'button';
            close.textContent = '×';
            close.setAttribute('aria-label', config.dataset.messageDismiss);
            close.addEventListener('click', () => { message.remove(); anchor?.focus(); });
            message.append(text, close);
            document.body.append(message);
          } else {
            window.location.assign(route === '/cart' ? config.dataset.cartUrl : config.dataset.accountUrl);
          }
        } else {
          accountOpenTimer = window.setTimeout(tryOpen, 100);
        }
      };
      tryOpen();
    };

    window.addEventListener('click', (event) => {
      const config = configuration();
      if (!config || !(event.target instanceof Element)) return;
      const savedButton = event.target.closest('.kl-hub-drawer .kl-hub-add-to-cart-button');
      const savedProduct = savedButton?.closest('.kl-hub-product-info');
      const savedLink = savedProduct?.querySelector('.kl-hub-product-info__product-name a');
      const savedTitle = savedProduct?.querySelector('.kl-hub-product-info__variant-name')?.textContent.trim();
      if (savedProduct?.querySelector('.kl-hub-wishlist-icon--active') && savedTitle && savedLink &&
          new URL(savedLink.href, window.location.href).origin === window.location.origin) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addSavedVariant(savedButton, savedProduct, config);
        return;
      }
      const account = event.target.closest('#site-control .nav-account[href="#k-hub"], #page-menu a[href="#k-hub"], .mobile-bottom-nav a[href="#k-hub"]');
      const favorites = event.target.closest('[data-bb-hub-favorites-link]');
      const routeFavorites = favorites && event.button === 0 &&
        !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
      const cart = event.target.closest('[data-bb-cart-link]');
      const routeAccount = account && event.button === 0 &&
        !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
      const routeCart = cart && config.dataset.cartEnabled === 'true' &&
        typeof window.customerHubApi?.open === 'function' &&
        event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
      if ((routeAccount || routeFavorites || routeCart) && typeof window.closeThemeModal === 'function') {
        window.closeThemeModal(true, null, false);
      }
      if (routeAccount || routeFavorites) {
        event.preventDefault();
        if (typeof window.customerHubApi?.open === 'function') event.stopImmediatePropagation();
        dismissAccountHint();
        openAccountHub(account || favorites, config, routeFavorites ? '/favorites' : '/');
        return;
      }
      if (routeCart) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openAccountHub(cart, config, '/cart');
      }
    }, true);

    if (window.PerformanceObserver?.supportedEntryTypes?.includes('resource')) {
      new PerformanceObserver((list) => {
        if (!configuration() || !window.customerHubApi) return;
        const cartChanged = list.getEntries().some((entry) => {
          if (!['fetch', 'xmlhttprequest'].includes(entry.initiatorType)) return false;
          const url = new URL(entry.name, window.location.href);
          return url.origin === window.location.origin &&
            /\/cart\/(change|update|clear)(\.js)?$/.test(url.pathname);
        });
        if (cartChanged) refreshCart();
      }).observe({ type: 'resource' });
    }

    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('error', (event) => {
      if (event.target instanceof HTMLImageElement && event.target.closest('.kl-hub-drawer')) scheduleUpdate();
    }, true);
    new MutationObserver(scheduleUpdate).observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['src']
    });
    updateHub();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-more-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-more-colors')) {
    customElements.define('bb-more-colors', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const initialize = () => {
          if (!this.isConnected || this.slider || !window.Swiper) return;
          const container = this.querySelector('.bb-more-colors__carousel');
          this.slider = new window.Swiper(container, {
            loop: false,
            freeMode: true,
            grabCursor: true,
            watchOverflow: true,
            slidesPerView: 3,
            spaceBetween: 12,
            speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
            mousewheel: { invert: true, forceToAxis: true },
            scrollbar: { el: container.querySelector('.swiper-scrollbar'), draggable: true },
            navigation: {
              nextEl: container.querySelector('.js-swiper-button-next'),
              prevEl: container.querySelector('.js-swiper-button-prev')
            },
            breakpoints: { 767: { slidesPerView: 2.3, spaceBetween: 12 } }
          });
        };
        initialize();
        document.addEventListener('DOMContentLoaded', initialize, { once: true, signal: this.events.signal });
        window.addEventListener('load', initialize, { once: true, signal: this.events.signal });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.slider?.destroy(true, true);
        this.slider = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-page-layout"] && !Shopify.designMode) return;
  try {
    (() => {
    let frame;
    let previousScroll = window.scrollY;
    const positions = new WeakMap();
    const sync = () => {
      frame = null;
      const header = document.getElementById('site-control');
      const position = header && getComputedStyle(header).position;
      const bottom = header && (position === 'fixed' || position === 'sticky')
        ? Math.max(0, header.getBoundingClientRect().bottom)
        : 0;
      const delta = window.scrollY - previousScroll;
      previousScroll = window.scrollY;
      document.querySelectorAll('.section-product-template .bb-product-single').forEach(gallery => {
        const media = gallery.querySelector('.product-area__media');
        if (!media) return;
        const maximum = bottom + 16;
        const minimum = Math.min(maximum, window.innerHeight - media.offsetHeight - 32);
        const previous = positions.get(gallery) ?? maximum;
        const top = window.scrollY === 0 ? maximum : Math.max(minimum, Math.min(maximum, previous - delta));
        positions.set(gallery, top);
        gallery.style.setProperty('--bb-gallery-top', `${top}px`);
      });
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(sync);
    };
    const headerChanges = new MutationObserver(schedule);
    const headerSize = new ResizeObserver(schedule);
    const mediaSize = new ResizeObserver(schedule);
    const observe = () => {
      headerChanges.disconnect();
      headerSize.disconnect();
      mediaSize.disconnect();
      const header = document.getElementById('site-control');
      if (header) {
        headerChanges.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
        headerSize.observe(header);
      }
      document.querySelectorAll('.section-product-template .bb-product-single .product-area__media').forEach(media => mediaSize.observe(media));
      schedule();
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('transitionend', schedule);
    document.addEventListener('shopify:section:load', observe);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
    else observe();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-thumbnail-arrows"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-thumbnail-arrows')) {
    customElements.define('bb-thumbnail-arrows', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.viewport = this.parentElement.querySelector('.bb-thumbnail-viewport');
          if (!this.viewport) return;
          this.previous = this.querySelector('[data-thumbnail-previous]');
          this.next = this.querySelector('[data-thumbnail-next]');
          this.events = new AbortController();
          const options = { signal: this.events.signal };
          this.previous.addEventListener('click', () => this.move(-1), options);
          this.next.addEventListener('click', () => this.move(1), options);
          this.viewport.addEventListener('scroll', () => this.update(), options);
          this.size = new ResizeObserver(() => this.update());
          this.size.observe(this.viewport);
          this.items = new MutationObserver(() => this.update());
          this.items.observe(this.viewport, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-cc-hidden', 'class'] });
          this.update();
        });
      }
      move(direction) {
        this.viewport.scrollBy({ top: direction * (this.viewport.clientHeight + 4), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const maximum = this.viewport.scrollHeight - this.viewport.clientHeight;
        this.hidden = maximum < 2;
        this.previous.disabled = this.viewport.scrollTop <= 2;
        this.next.disabled = this.viewport.scrollTop >= maximum - 2;
      }
      disconnectedCallback() {
        this.events?.abort();
        this.size?.disconnect();
        this.items?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
